import { knowYourRightsMenu, topMenu, productsMenu, companyMenu, supportMenu, legalMenu, imprintMenu } from "./menus";
import type { MenuProps, MenuExtendedProps } from "./menus.d";

export {
  knowYourRightsMenu,
  topMenu,
  productsMenu,
  companyMenu,
  supportMenu,
  legalMenu,
  imprintMenu,
  MenuProps,
  MenuExtendedProps,
};
